module.exports = __webpack_public_path__ + "img/grandmas_cookies.9d002b2f.jpg";